export default "__VITE_ASSET__B9EV6tXw__"